
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import AbpBase from '../../../lib/abpbase'
    class RejectionProcessFailure {
        id: number;
        processReMark: string;
    }
    @Component
    export default class RejectionProcessFailureModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        rejectionProcessFailure: RejectionProcessFailure = new RejectionProcessFailure();
        submit() {
            this.save();
        }
        async save() {
                    await this.$store.dispatch({
                        type: 'returnrejection/processFaile',
                        data: this.rejectionProcessFailure
                    });
                    (this.$refs.RejectionProcessFailureForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
        }
        cancel() {
            (this.$refs.RejectionProcessFailureForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                var data = this.$store.state.returnrejection.processFaileInfo;
                this.rejectionProcessFailure.id = data.id;
                this.rejectionProcessFailure.processReMark = '';
            }
        }

    }
